// This file was automatically generated from no_memo.html
// Any changes to this file will be overwritten when the script is run again

const memoContent = `<!DOCTYPE html>
<!-- saved from url=(0029)https://myafterimage.com/memo -->
<html lang="en"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Afterimage: Fixing Healthcare by Democratizing Accountability for Patients and Consumers</title>
    <style>
        body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #ffffff;
        }
        .page-container {
            display: grid;
            grid-template-columns: 1fr minmax(800px, 1000px) 1fr;
            max-width: 100%;
            min-height: 100vh;
        }
        .left-column {
            position: relative;
        }
        .toc-wrapper {
            position: sticky;
            top: 2rem;
            padding: 0 1rem;
            display: flex;
            justify-content: flex-end;
            height: fit-content;
        }
        .main-column {
            padding: 2rem 3rem;
            background-color: #ffffff;
        }
        .right-column {
            /* Empty right column, equal to left column */
        }
        h1, h2, h3, h4 {
            font-weight: 600;
            color: #1a1a1a;
            margin-top: 1.5em;
            margin-bottom: 0.75em;
        }
        h1 {
            font-size: 2.2rem;
            margin-top: 0;
            color: #2563eb;
        }
        h2 {
            font-size: 1.5rem;
            border-bottom: 1px solid #eaeaea;
            padding-bottom: 0.5rem;
        }
        h3 {
            font-size: 1.25rem;
            margin-bottom: 0.25rem;
        }
        
        /* Add styles for Appendix section headings */
        #appendix ~ h3 {
            border-bottom: 1px solid #eaeaea;
            padding-bottom: 0.5rem;
            margin-top: 2rem;
        }
        
        p {
            margin-bottom: 1.2em;
        }
        .highlight {
            background-color: #f0f7ff;
            padding: 1rem;
            border-left: 4px solid #2563eb;
            border-radius: 0 4px 4px 0;
            margin: 1.5rem 0;
        }
        .statistics {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
            margin: 2rem 0;
        }
        .stat-box {
            flex: 1;
            min-width: 200px;
            background-color: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 1rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        .stat-number {
            font-size: 1.8rem;
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.5rem;
        }
        .stat-label {
            font-size: 0.9rem;
            color: #4b5563;
        }
        .team-section {
            display: flex;
            flex-wrap: wrap;
            gap: 2rem;
            margin-top: 2rem;
        }
        .team-member {
            flex: 1;
            min-width: 250px;
        }
        .team-member-image {
            margin: 0 auto 1rem auto;
            text-align: center;
        }
        .team-member h3 {
            margin-top: 0;
            margin-bottom: 0.5rem;
            text-align: left;
        }
        .quote {
            font-style: italic;
            color: #4b5563;
            padding-left: 1rem;
            border-left: 3px solid #d1d5db;
            margin: 1.5rem 0;
        }
        footer {
            margin-top: 3rem;
            border-top: 1px solid #eaeaea;
            padding-top: 1.5rem;
            font-size: 0.9rem;
            color: #6b7280;
            grid-column: 1 / -1;
            background-color: #ffffff;
        }
        
        /* Table of Contents Styles */
        .toc-container {
            background-color: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 1.2rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            width: 250px;
            height: fit-content;
        }
        .toc-header {
            color: #2563eb;
            font-size: 1.2rem;
            font-weight: 600;
            margin: 0;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
        }
        .toc-header:after {
            content: '▼';
            font-size: 0.8rem;
            color: #4b5563;
            transition: transform 0.3s ease;
        }
        .toc-header.collapsed:after {
            transform: rotate(-90deg);
        }
        .toc-content {
            height: fit-content;
            overflow: hidden;
            transition: all 0.3s ease;
        }
        .toc-content.collapsed {
            height: 0;
            opacity: 0;
        }
        .toc-list {
            list-style-type: none;
            padding: 0;
            margin: 0.75rem 0 0;
        }
        .toc-list li {
            margin-bottom: 0.75rem;
            font-weight: 500;
            font-size: 0.9rem;
            line-height: 1.2;
        }
        .toc-list li:last-child {
            margin-bottom: 0;
        }
        .toc-list li a {
            color: #1a1a1a;
            text-decoration: none;
            transition: color 0.2s ease;
            display: flex;
            align-items: center;
            padding: 0.25rem 0;
        }
        .toc-list li a:hover {
            color: #2563eb;
        }
        .toc-list li a:before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            margin-right: 8px;
            background-color: #2563eb;
            border-radius: 50%;
        }
        
        /* Add styles for nested TOC items */
        .toc-list .toc-list {
            margin-left: 1.5rem;
            margin-top: 0.5rem;
        }
        .toc-list .toc-list li a:before {
            width: 4px;
            height: 4px;
            background-color: #6b7280;
        }
        
        .footer-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 0 3rem;
        }
        
        /* Mobile TOC and responsive fixes */
        .mobile-toc {
            display: none;
            margin-bottom: 2rem;
        }
        .mobile-toc .toc-container {
            width: auto;
            max-width: 90%;
            margin: 0 auto;
        }
        
        /* Responsive adjustments */
        @media (max-width: 1200px) {
            .page-container {
                grid-template-columns: 1fr minmax(800px, 1000px) 1fr;
            }
        }
        
        @media (max-width: 1024px) {
            /* Reset the grid layout completely for mobile */
            .page-container {
                display: block;
                width: 100%;
                max-width: 100%;
                margin: 0 auto;
            }
            .main-column {
                width: 100%;
                max-width: 100%;
                padding: 1rem;
                box-sizing: border-box;
            }
            .left-column, .right-column {
                display: none;
            }
            /* Show TOC at the top for mobile */
            .mobile-toc {
                display: block;
                padding: 0 1rem;
                margin-bottom: 2rem;
            }
            /* Fix footer for mobile */
            footer {
                width: 100%;
            }
            .footer-container {
                width: 100%;
                padding: 0 1rem;
                box-sizing: border-box;
            }
            /* Make statistics responsive on small screens */
            .statistics {
                flex-direction: column;
            }
            .stat-box {
                min-width: 100%;
                margin-bottom: 1rem;
            }
            /* Make team section responsive */
            .team-section {
                flex-direction: column;
            }
            /* Adjust title size for mobile */
            .main-title {
                font-size: 3rem;
            }
            /* Additional fixes for mobile display */
            footer ol {
                padding-left: 1.5rem; /* Reduce the left padding of the list */
            }
            /* Additional TOC adjustments for mobile */
            .mobile-toc .toc-container {
                max-width: 100%;
                box-sizing: border-box;
            }
        }
        
        .title-container {
            margin-bottom: 2rem;
            text-align: center;
        }
        .main-title {
            font-size: 4.5rem;
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.5rem;
            font-family: 'Montserrat', 'Inter', sans-serif;
            letter-spacing: -0.03em;
        }
        .subtitle {
            font-size: 1.5rem;
            color: #4b5563;
            max-width: 800px;
            margin: 0 auto 1.5rem auto;
            line-height: 1.4;
        }
        .executive-summary {
            font-size: 1.2rem;
            line-height: 1.8;
            margin-bottom: 1.5rem;
            color: #1a1a1a;
        }
        /* Add these styles to fix the citation width issue */
        footer ol {
            max-width: 100%;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }
        footer ol li {
            max-width: 100%;
            margin-bottom: 0.75rem;
        }
        footer ol li a {
            word-break: break-all; /* Forces very long URLs to break */
        }
    </style>
</head>
<body>
    <div class="page-container">
        <div class="left-column">
            <div class="toc-wrapper">
                <div class="toc-container">
                    <h2 class="toc-header" id="tocToggle">Table of Contents</h2>
                    
                    <div class="toc-content" id="tocContent">
                        <ul class="toc-list">
                            <li><a href="#executive-summary">Executive Summary</a></li>
                            <li><a href="#problem">The Problem: Structural Incentive Misalignment</a></li>
                            <li><a href="#personal-stake">My Personal Stake</a></li>
                            <li><a href="#solution">Solution</a></li>
                            <li><a href="#team">Team</a></li>
                            <li><a href="#investors">Investors</a></li>
                            <li><a href="#appendix">Appendix</a>
                                <ul class="toc-list" style="margin-left: 1.5rem;">
                                    <li><a href="#market-opportunity">Market Opportunity</a></li>
                                    <li><a href="#solution-details">Solution: Disrupting the Medical Justice Ecosystem</a></li>
                                    <li><a href="#business-model">Business Model</a></li>
                                    <li><a href="#traction">Traction</a></li>
                                    <li><a href="#patient-strategy">Patient Acquisition Strategy</a></li>
                                    <li><a href="#competitive-moat">Competitive Moat</a></li>
                                    <li><a href="#provider-strategy">Fixing Failing Healthcare Providers</a></li>
                                    <li><a href="#insurance-strategy">Fixing Broken Malpractice Insurance</a></li>
                            <!--<li><a href="#investors">Investors</a></li>-->
                            <!--<li><a href="#our-journey">Our Journey</a></li>-->
                            <li><a href="#timing">The Timing is Now</a></li>
                            <li><a href="#advocate">Vision 1: An Advocate for the Future of Healthcare</a></li>
                            <li><a href="#vision">Vision 2: Restructuring Healthcare Market Dynamics</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="main-column">
            <div class="title-container">
                <h1 class="main-title">Afterimage</h1>
                <p class="subtitle">Fixing Healthcare by Democratizing Accountability for Consumers</p>
            </div>
            
            <!-- Add mobile TOC right after the title/subtitle -->
            <div class="mobile-toc">
                <div class="toc-container">
                    <h2 class="toc-header collapsed" id="mobileTocToggle">Table of Contents</h2>
                    
                    <div class="toc-content collapsed" id="mobileTocContent">
                        <ul class="toc-list">
                            <li><a href="#executive-summary">Executive Summary</a></li>
                            <li><a href="#problem">The Problem: Structural Incentive Misalignment</a></li>
                            <li><a href="#personal-stake">My Personal Stake</a></li>
                            <li><a href="#solution">Solution</a></li>
                            <li><a href="#team">Team</a></li>
                            <li><a href="#investors">Investors</a></li>
                            <li><a href="#appendix">Appendix</a>
                                <ul class="toc-list" style="margin-left: 1.5rem;">
                                    <li><a href="#market-opportunity">Market Opportunity</a></li>
                                    <li><a href="#solution-details">Solution: Disrupting the Medical Justice Ecosystem</a></li>
                                    <li><a href="#business-model">Business Model</a></li>
                                    <li><a href="#traction">Traction</a></li>
                                    <li><a href="#patient-strategy">Patient Acquisition Strategy</a></li>
                                    <li><a href="#competitive-moat">Competitive Moat</a></li>
                                    <li><a href="#provider-strategy">Fixing Failing Healthcare Providers</a></li>
                                    <li><a href="#insurance-strategy">Fixing Broken Malpractice Insurance</a></li>
                            <!--<li><a href="#investors">Investors</a></li>-->
                            <!--<li><a href="#our-journey">Our Journey</a></li>-->
                            <li><a href="#timing">The Timing is Now</a></li>
                            <li><a href="#advocate">Vision 1: An Advocate for the Future of Healthcare</a></li>
                            <li><a href="#vision">Vision 2: Restructuring Healthcare Market Dynamics</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <h2 id="executive-summary">Executive Summary</h2>
            
            <p class="executive-summary">Afterimage is addressing a critical market failure in healthcare: while diagnostic errors permanently disable or kill nearly one million Americans annually, the current system economically discourages technologies that catch and alert patients about medical errors because they expose providers to increased legal risk and financial liability.</p>
            
            <p class="executive-summary">Our AI-powered platform corrects this market failure by making it financially advantageous for healthcare providers to implement transparent error detection technologies rather than conceal mistakes. By realigning incentives within the healthcare system, we're creating the market conditions for widespread adoption of life-saving diagnostic technologies while building a $100M+ annual revenue business.</p>
            
            <h2 id="problem">The Problem: Structural Incentive Misalignment</h2>
            
            <p>The U.S. healthcare system faces a profound misalignment of economic and safety incentives. Studies indicate that approximately 20% of adults have experienced medical errors at some point in their lives<sup>1</sup>, with a significant subset facing life-changing consequences:</p>

            <div class="statistics">
                <div class="stat-box">
                    <div class="stat-number">800K-1.1M</div>
                    <div class="stat-label">Annual cases of permanent disability or death from diagnostic errors<sup>2</sup></div>
                </div>
                <div class="stat-box">
                    <div class="stat-number">$300B+</div>
                    <div class="stat-label">Annual economic burden from medical errors<sup>3</sup></div>
                </div>
                <div class="stat-box">
                    <div class="stat-number">&lt;10,000</div>
                    <div class="stat-label">Medical malpractice claims investigated annually<sup>4</sup></div>
                </div>
            </div>

            <p>The time and expense required to evaluate complex medical cases, together with the extremely limited supply of medical-legal experts, creates a bottleneck that prevents most legitimate cases from ever being investigated. Even in cases of catastrophic errors like wrong-site surgeries, researchers found that only 21.5 percent of affected patients filed a claim for investigation<sup>7</sup>.</p>

            <p>During conversations with healthcare administrators and through my brother's experience starting and operating radiology clinics, I've witnessed firsthand how healthcare providers routinely reject AI diagnostic technologies despite their proven efficacy<sup>5</sup>. When pitched these solutions, clinics consistently decline adoption – not because of technological limitations but because of liability concerns. When asked if they would adopt an AI system designed to automatically identify potentially risky decisions made by physicians, the chairman of Mount Sinai Hospital's malpractice insurance board bluntly stated:</p>

            <div class="quote">
                <p>"Never. We'd go from 20 claims a quarter to 2000 claims a quarter."</p>
            </div>

            <p>This represents a textbook case of incentive misalignment. The current system economically rewards healthcare providers and insurers for maintaining information asymmetry rather than implementing error prevention technologies. While patients and insurance companies absorb the $300B+ annual cost burden, structural market barriers prevent the implementation of readily available technological solutions.</p>

            <h2 id="personal-stake">My Personal Stake</h2>

            <p>After my mother's cancer diagnosis, I became a magnet for troubling healthcare stories. My friend described being sent home despite non-stop nosebleeds and fainting spells that left her dizzy for days. My uncle complained about stabbing stomach pain for months before doctors finally ordered the test that revealed the real problem. My friend's grandmother never missed her annual cancer screenings yet was suddenly diagnosed with stage IV cancer.</p>
            <p>I personally drove to multiple hospitals to get their medical records and MRIs, and approached numerous attorneys, most of whom declined these cases without investigation – not for lack of merit, but because of economic constraints in case selection.</p>

            <p>Eventually, one attorney agreed to review the medical records I had collected. For our family friend with cancer, we discovered unmistakable evidence of a tumor in her previous scan that had been overlooked. While we won $3M in compensation, no amount could restore her health or compensate for the unnecessary suffering she endured. This should have never happened, and we want to prevent it from ever happening again, to anyone.</p>

            <p>This experience illuminated a fundamental market inefficiency: the system isn't failing because of technological limitations, but because structural incentives actively discourage the adoption of technologies that could save hundreds of thousands of lives annually.</p>

            <h2 id="solution">Solution</h2>

            <p>Afterimage is building a platform that gives patients rapid clarity when they suspect medical errors, while protecting good doctors from non-meritorious claims. Our system automates the complete medical investigation pipeline end-to-end, reducing review time from weeks to hours.</p>

            <p>We are building a platform that can:</p>

            <ul>
                <li>Automatically retrieve and analyze medical records from multiple providers</li>
                <li>Conduct physician-level diagnostic review and treatment evaluation</li>
                <li>Generate comprehensive case documentation and merit assessment for standard of care violations</li>
                <li>Optimize settlement resolution through automated lien appeals</li>
            </ul>

            <p>With a median case value of $300,000 and a 25% take rate, handling just over 1,300 cases per year is enough to reach $100 million in annual revenue. This straightforward math shows how scale alone, even at industry-standard settlement values, can drive a nine-figure business and fund our mission to build the world's most comprehensive dataset of healthcare risk patterns.</p>

            <p>Our unique competitive moat comes from building the only real-time heatmap of liability and risk across all healthcare providers in the country, grounded in actual patient complaints and outcomes. This dataset links patient concerns, medical records, and case resolutions everywhere from small rural clinics to major metropolitan health systems, giving us a nationwide view that no law firm, hospital, or insurer can match. As we capture more data, our system becomes increasingly accurate at identifying valid cases, creating a reputation that accelerates settlements and attracts more cases, and a flywheel that locks out competitors.</p>

            <p>Providers and insurers that fail to adopt better technology may experience 10-100x increases in malpractice insurance premiums and costs, facing risks of insolvency or severely compressed margins due to negligent behavior that could have been prevented. This creates a powerful incentive for the industry to embrace proactive risk management and technological solutions.</p>

            <p>Ultimately, our unique, structured dataset allows us to partner with health systems and insurers to help them prevent errors through risk detection and proactive defense tools. With cross-system data that spots patterns no single provider or malpractice insurer can see, we'll price risk more accurately, prevent negligent behavior at the source, and position ourselves to transform or acquire pieces of the massive healthcare liability risk market.</p>

            <p>Our real-time heatmap of liability and risk across all healthcare providers in the country will enable us to identify and target both healthcare providers and malpractice insurance carriers for acquisition, roll-up, and optimization, offering a path to stability and improvement for institutions whose care could be significantly improved with AI.</p>

            <p>For a detailed exploration of our market opportunity, technical implementation, competitive advantages, and business model, please see the Appendix.</p>

            <h2 id="team">Team</h2>

            <div class="team-section">
                <div class="team-member">
                    <div class="team-member-image" style="width: 120px; height: 120px; border-radius: 60px; background-image: url(&#39;/images/andrew.jpg&#39;); background-size: cover; background-position: center; margin: 0 auto 1rem auto;"></div>
                    <h3 style="text-align: left;">Andrew Gregory</h3>
                    <h3 style="text-align: left; font-weight: 500; color: #4b5563; margin-top: -0.5rem;">Founder &amp; CEO</h3>
                    <p>Creator of <a href="https://github.com/noncomputable/AgentMaps">AgentMaps</a>, #1 open-source social simulation software on GitHub</p>
                    <p>Senior <a href="https://noncomputable.github.io/evolution">AI Engineer</a> at Roivant Sciences</p>
                    <p>Worked on simulating epidemics and scientific innovation with DARPA for <a href="https://www.osti.gov/servlets/purl/1812588">Ground Truth</a></p>
                    <p>Started <a href="https://www.playpiper.com/">ed-tech startup in high school</a></p>

                </div>
                
                <div class="team-member">
                    <div class="team-member-image" style="width: 120px; height: 120px; border-radius: 60px; background-image: url(&#39;/images/peter.jpg&#39;); background-size: cover; background-position: center; margin: 0 auto 1rem auto;"></div>
                    <h3 style="text-align: left;">Peter Anderson</h3>
                    <h3 style="text-align: left; font-weight: 500; color: #4b5563; margin-top: -0.5rem;">Founding Partner &amp; CLO</h3>
                    <p>Founding Partner of <a href="https://www.forthepeople.com/verdicts-and-settlements-var/v2/">Morgan &amp; Morgan's</a> DC branch</p>
                    <p>Senior attorney at influential medical malpractice firm</p>
                    <p>Secured 8-figure settlements for patients</p>
                    <p>From medical family (father and sister are surgeons)</p>
                    <p>Specialized expertise in regulatory environment for legal-technology partnerships</p>
                </div>

                <div class="team-member">
                    <div class="team-member-image" style="width: 120px; height: 120px; border-radius: 60px; background-image: url(&#39;/images/james.jpeg&#39;); background-size: cover; background-position: center; margin: 0 auto 1rem auto;"></div>
                    <h3 style="text-align: left;">James Imrie</h3>
                    <h3 style="text-align: left; font-weight: 500; color: #4b5563; margin-top: -0.5rem;">Founding Creative Director</h3>
                    <p>Creative director at BetterHelp during peak growth (2018-2023)</p>
                    <p>Built and led creative team responsible for global brand and content strategy</p>
                    <p>Kickstarted BetterHelp's creator partnerships and community-driven content</p>
                    <p>Executive consultant in dozens of consumer health companies</p>
                </div>
            </div>

            <h2 id="investors">Investors</h2>
            <div class="team-section">
                <div class="team-member">
                    <h3>Institutions</h3>
                    <ul>
                        <li>Betaworks Ventures</li>
                        <li>True Ventures</li>
                        <li>Salesforce Ventures</li>
                        <li>Fermont Capital (Richard Reese, ex-CEO of Iron Mountain)</li>
                        <li>Moth Fund (Molly Mielke)</li>
                    </ul>
                </div>
                
                <div class="team-member">
                    <h3>Individuals</h3>
                    <ul>
                        <li>Michael Ioffe (Thiel Fellow, Founder/CEO of Series A startup Arist)</li>
                        <li>Kumar Abihrup (Founder of YC-backed legal AI startup)</li>
                        <li>Mark Pavlyyukovsky (GP @ NZVC, Andrew's former cofounder)</li>
                    </ul>
                </div>
            </div>

            <h2 id="appendix">Appendix</h2>

            <h3 id="market-opportunity">Market Opportunity: Strategic Intervention in the Infrastructure of Medical Accountability</h3>

            <p>The pervasiveness of misdiagnosis and mistreatment reveals critical inefficiencies in healthcare. They both jeopardize patient safety and present a significant opportunity for solutions that can fix them:</p>

            <ul>
                <li><strong>Specialized Expertise Bottleneck:</strong> While tens of thousands of personal injury attorneys operate nationwide, only a few hundred to a few thousand possess the specialized expertise required for effective medical malpractice litigation<sup>6</sup>, creating a severe capacity constraint for case evaluation and representation</li>
                <li><strong>Income-Based Case Selection Bias:</strong> Practitioners reject 95% of potential cases immediately based on the patient's income potential (which directly affects potential damages) rather than case merit<sup>7</sup>, creating significant market distortion where legitimate claims from lower-income patients are systematically ignored</li>
                <li><strong>Socioeconomic Access Disparity:</strong> Lower-income patients receiving care at under-resourced facilities face both higher rates of medical error<sup>1</sup> and dramatically lower access to legal remedies, creating a profound equity gap in healthcare accountability</li>
                <li><strong>Investigation Capital Requirements:</strong> Case evaluation demands specialized expertise, extensive document analysis, and substantial upfront capital that creates barriers to market efficiency</li>
            </ul>

            <p>This market dysfunction creates a paradox: victims with legitimate malpractice claims receive no representation, while many cases attorneys pursue are totally frivolous. We're deploying AI-powered case screening that dramatically reduces evaluation costs, enabling a more efficient medical justice market while simultaneously protecting healthcare providers from non-meritorious claims.</p>

            <h3 id="solution-details">Solution: Disrupting the Medical Justice Ecosystem</h3>

            <h4>Protecting Good Doctors, Supporting Legitimate Claims</h4>

            <p>The current medical malpractice system harms everyone: patients who deserve justice rarely get it, while dedicated physicians face baseless claims that waste time and damage reputations. Our precision-targeted approach identifies legitimate cases with surgical accuracy while shielding conscientious physicians from frivolous litigation. By distinguishing between unavoidable outcomes and genuine negligence, we're creating space for what healthcare desperately needs: transparency without fear.</p>

            <h4>Insurance Recovery Optimization</h4>

            <p>The $300B+ annual burden of medical errors is distributed across both patients and insurance companies, with insurers bearing significant losses that are rarely recovered through existing mechanisms. Our AI-powered subrogation and lien optimization system creates a dual benefit: helping patients maximize their settlement recovery while simultaneously enabling insurance companies to recapture billions in previously unrecoverable losses. By efficiently aligning interest recovery across the ecosystem, we're creating a more economically sustainable healthcare accountability framework that benefits all legitimate stakeholders.</p>

            <h4>Expanding the Labor Supply</h4>

            <p>There are 135,000 personal injury attorneys in the US, but vast majority avoid medical malpractice cases  –  not because they don't want to help, but because they lack the specialized expertise, confidence, and resources to make these complex cases viable. As a result, patients are routinely referred to a tiny pool of overburdened specialists, leaving countless legitimate claims unserved.

            <p>Afterimage eliminates those barriers. By equipping every case with an AI malpractice attorney agent  –  including point-by-point explanations of the evidence, strategic playbooks, deposition prep, and access to typically costly settlement services at no cost  –  we eliminate the barriers that keep general attorneys from serving patients in need. This expands the supply of capable medical justice advocates by 100×, giving more patients a real path to justice and more attorneys the tools to confidently take these cases on.
            
            <h4>Phase 2: Systemic Transformation</h4>

            <p>As we scale, we'll normalize the expectation that patients can and should verify their diagnoses when they feel uncertain. This cultural shift will force healthcare providers and malpractice insurers to proactively identify and prevent errors – because being transparent about potential errors will become less costly than facing a tidal wave of legitimate claims.</p>

            <p>Our long-term vision is to transition from reactive legal advocacy to proactive error prevention, offering our AI diagnostic tools directly to healthcare providers and malpractice insurers with a unique value proposition: "Your patients already use us to file claims after being mistreated – why not use our tools to protect them preemptively?"</p>

            <h3 id="business-model">Business Model</h3>

            <p>Afterimage is not just a legal services company. We are building the first comprehensive platform and consumer brand for anyone experiencing dissatisfaction with their healthcare. Our platform is designed to serve the full spectrum of patient needs, from those simply seeking peace of mind or clarity about their care, to those wanting a second opinion, all the way to patients with clear evidence of harm who may pursue malpractice litigation. This approach allows us to monetize across a wide range of patient experiences, including low-cost peace of mind reports, second opinion steering, and, when appropriate, legal case triage and referral. By meeting patients where they are, regardless of whether they want to sue, seek answers, or just feel heard, we dramatically expand our total addressable market and create a trusted brand that can serve as the default destination for healthcare accountability and support.</p>

            <h4>Market Size</h4>
            <p>The total addressable market for Afterimage is vast, reflecting the millions of Americans who experience dissatisfaction, confusion, or harm in their healthcare journeys each year. At the broadest level, up to 30% of U.S. adults (about 78 million people) report feeling misdiagnosed or mistreated at some point. Even if only a fraction of these individuals seek out support, the opportunity is enormous:</p>
            <ul>
              <li><strong>Malpractice Claims:</strong> There are an estimated 800,000 diagnostic errors causing permanent disability or death annually in the U.S. If every incident resulted in a claim with a $300,000 median payout, the theoretical maximum market would be $240 billion per year. Even activating just 5 to 10 percent of these latent cases (40,000 to 80,000 cases per year) would represent $12 to $24 billion in new annual payouts, far exceeding the current $4 to $6 billion paid out each year.</li>
              <li><strong>Second Opinion Steering:</strong> The global medical second opinion market is projected to reach $20.45 billion by 2031, with the U.S. representing about 40 percent (around $8 billion). If even 10 percent of the 78 million adults who feel misdiagnized sought a $300 second opinion, that would represent a $2.3 billion annual U.S. market. The maximal global opportunity is much larger.</li>
              <li><strong>Closure Reports:</strong> Many people who feel misdiagnized or mistreated do not have an obvious legal case and are unlikely to be heard by law firms. For these individuals, Afterimage offers closure reports that help them understand their situation and move forward, reducing frustration and uncertainty with the healthcare system. If every one of the 78 million adults who feel misdiagnized purchased a $30 closure report, the maximal market would be $2.34 billion annually. Even at 5 percent penetration, this is a $117 million market.</li>
            </ul>
            <p>This multi-tiered approach, serving everyone from the mildly concerned to the severely harmed, positions Afterimage to capture value at every stage of the patient journey. It also builds a data and brand moat that competitors cannot easily replicate.</p>

            <p>Our initial revenue model is based on contingency fee sharing with attorney partners:</p>
            <ul>
                <li>Median settlement: $300,000</li>
                <li>Afterimage revenue share: 20-60% (varies by state and case)</li>
                <li>Target: 100 cases per year initially, scaling to 1,500+</li>
                <li>Projected annual revenue at scale: $100M+</li>
            </ul>

            <p>This combination yields over 15× the net revenue of traditional firms with identical patient acquisition budgets. By reducing qualification costs dramatically, we accept many more viable claims, creating exploding margins that will let us re-invest and scale.</p>

            <h3 id="traction">Traction</h3>
            <p>We have been formally approved by the DC bar to operate as a non-lawyer owned law firm entity and have established a 50/50 revenue sharing agreement with our legal partner, a successful medical malpractice attorney already handling a 7-figure caseload. This regulatory milestone enables us to align incentives across technology and legal expertise.</p>
            <p>Leveraging this foundation, our patient acquisition efforts have rapidly generated a diverse and engaged pipeline of cases, validating both the scale and urgency of the problem:</p>
            <ul>
                <li><strong>Error Types:</strong> The majority of cases involve misdiagnosis, with significant representation from delayed treatment, surgical errors, and other forms of medical harm.</li>
                <div style="margin: 1rem 0 1.5rem 0;">
                    <img src="/images/maltype_piechart.png" alt="Distribution of medical error types" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
                <li><strong>Clinical Specialties:</strong> Cases span a wide range of specialties, including orthopedics, neurology, cancer, and gastrointestinal medicine, demonstrating the broad relevance of our solution.</li>
                <div style="margin: 1rem 0 1.5rem 0;">
                    <img src="/images/disarea_piechart.png" alt="Distribution of clinical specialties" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
                <li><strong>Geographic Reach:</strong> We've attracted cases from nearly every major healthcare market nationwide, with a healthy mix of both large states and smaller regions.</li>
                <div style="margin: 1rem 0 1.5rem 0;">
                    <img src="/images/state_piechart.png" alt="Geographic distribution of cases" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
                <li><strong>Reporting Timelines:</strong> Patients are coming forward both immediately after incidents and years later, showing the persistent impact of medical errors and the trust we're building as a destination for those seeking answers.</li>
                <div style="margin: 1rem 0 1.5rem 0;">
                    <img src="/images/timechart.png" alt="Time between incident and report" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
            </ul>

            <h3 id="patient-strategy">Patient Acquisition Strategy</h3>

            <p>There is a massive cultural zeitgeist of overwhelming distrust towards healthcare institutions, evidenced by viral discussions of "medical gaslighting" and celebrities sharing misdiagnosis stories every few weeks. Yet there's no trusted consumer brand for addressing these concerns – we're positioning to become the default destination for patients seeking validation and resolution.</p>

            <div style="margin: 2rem 0;">
                <div style="margin-bottom: 2rem;">
                    <img src="/images/twitterboxer.png" alt="Viral tweet about medical misdiagnosis" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
                <div>
                    <img src="/images/tiktok.png" alt="Mosaic of viral TikTok videos about medical mistreatment" style="width: 100%; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                </div>
            </div>

            <p>Our approach taps into this organic frustration with healthcare on social media. By positioning ourselves as advocates rather than litigators, we've reduced patient acquisition costs from the industry standard of $80 to just $4.30 per lead. This dramatic reduction comes from:</p>

            <ul>
                <li>Creating content that resonates with patients' real experiences</li>
                <li>Leveraging viral trends around medical mistreatment</li>
                <li>Building trust through authentic storytelling</li>
                <li>Engaging with communities facing healthcare challenges</li>
            </ul>

            <p>We've identified a critical psychological barrier that creates significant market opportunity: while patients deeply desire peace of mind and a sense of justice after experiencing potential medical errors, most find the prospect of directly engaging with attorneys profoundly intimidating. Even when faced with clear violations of care standards, patients lack self-confidence in their medical understanding and feel uncomfortable with the cultural implications of "suing a doctor."</p>

            <p>By establishing a consumer-friendly gateway focused on validation and clarity rather than litigation, we're creating an entirely new pathway for patients to address medical concerns. This approach simultaneously expands the total addressable market by reaching patients who would never contact attorneys directly, while creating a powerful brand position that established legal entities cannot credibly replicate.</p>

            <h3 id="competitive-moat">Competitive Moat</h3>
            <p>Our competitive advantages don't just stack, they compound. Each element reinforces the others, creating a self-reinforcing cycle that makes it increasingly difficult for competitors to enter the market, even with significant capital and technical expertise. The combination of our specialized data, trusted brands, and efficient case evaluation creates a flywheel effect: more cases to better data to more accurate assessments to faster settlements to stronger reputation to more cases. This cycle accelerates over time, making it virtually impossible for new entrants to catch up, as they would need to simultaneously build competitive data assets, brand trust, and operational efficiency, all while competing against our established network effects.</p>

            <h4>Legal Network and Acquisition Strategy</h4>
            <p>Our cofounder serves as senior attorney and is the designated successor to one of the most influential medical malpractice firms in the United States. This firm boasts the #1 following among medical malpractice attorneys on LinkedIn, maintains an active seven-figure caseload, and has cultivated a massive referral network of hundreds of attorneys nationwide.</p>
            <p>This strategic partnership positions us for a powerful acquisition approach, leveraging an established, reputable brand with deep expertise in medical malpractice litigation. Rather than building a referral network from scratch – a typical barrier to entry in this space – we're able to immediately tap into a mature ecosystem of specialized attorneys who already collaborate on case distribution based on jurisdiction and specialization.</p>
            <p>The combination of our advanced AI case evaluation technology with this established legal network creates a unique competitive advantage: we can immediately deploy our technological innovations through trusted channels that typically take years to develop. This approach dramatically accelerates our go-to-market timeline while providing the credibility that only comes from association with recognized leaders in medical justice advocacy.</p>

            <h4>Data Moat</h4>
            <p>Unlike code or images, you can't hire off-shore workers to make the data needed to train models for medical safety and error detection, i.e. 5000 page medical records that contain errors and latent predictors of patient dissatisfaction. The only way to get it is by being the trusted intake layer when patients believe something went wrong and capture the data in the wild, as Cursor does with code reversions and Midjourney does with image reactions.</p>
            <p>Each case we process generates a rare, highly structured dataset: a complete medical record, patient suspicion of error, viability (whether an attorney accepted the case), and the magnitude of the case outcome. This gives us the world's largest, real-world dataset of errors, adverse events, and near misses  –  an asset no one else has.</p>
            <p>This feedback loop deepens the moat: the more patients come to us, the better our AI becomes at identifying real medical negligence, predicting claim outcomes, and ultimately improving clinical safety. Over time, our clinical AI agents won't just detect errors  –  they'll prevent the kinds of experiences that trigger complaints in the first place and serve as the foundation for the safest, most patient-friendly clinical services in the world.</p>
            
            <h4>Technology Differentiation</h4>
            <p>Unlike horizontal legal tech SaaS providers that offer generic document analysis for personal injury firms, our systems are deeply specialized for medical malpractice evaluation and diagnostics. As end-users of our own technology, we're incentivized to build what actually works rather than what looks impressive in sales demos to law firms.</p>
            <p>The market is saturated with hundreds of companies offering "AI MedChrons and Demand letters" as generic SaaS products – a number soon to be in the thousands as AI document summarization and generation becomes increasingly commodified. Our approach stands in deliberate contrast to this trend.</p>
            <p>Coming from a background as a senior researcher in ML for cancer therapeutics with its rigorous precision requirements, we've developed systems specifically optimized for identifying patterns of medical negligence with all its nuances, rather than just summarizing records.</p>
            <p>Our record retrieval automation, evidence highlighting, and case preparation systems have been battle-tested in real cases against skeptical experts. This specialized focus creates significant barriers to commoditization even as general AI capabilities advance.</p>

            <h3 id="provider-strategy">Fixing Failing Healthcare Providers</h3>

            <p>The healthcare provider market is ripe for transformation. Small and mid-sized providers face mounting pressure from rising malpractice costs, quality requirements, and technological demands. Our unique position at the intersection of healthcare quality and risk management gives us an unprecedented ability to identify and transform struggling providers before others can spot the opportunity.</p>

            <p>Our acquisition and transformation process:</p>

            <ul>
                <li>Identify providers facing quality or financial challenges through our comprehensive risk dataset</li>
                <li>Acquire at significant discounts to industry multiples</li>
                <li>Implement advanced quality assurance and risk management systems</li>
                <li>Optimize operations through AI-driven insights</li>
                <li>Roll up into regional networks for economies of scale</li>
            </ul>

            <p>This strategy represents a fundamental shift in how healthcare quality and risk are managed. Rather than waiting for problems to emerge, we proactively identify and address quality challenges before they impact patient care or provider sustainability.</p>

            <h3 id="insurance-strategy">Fixing Broken Malpractice Insurance</h3>

            <p>The medical malpractice insurance market is at an inflection point. With $11.7B in North American premiums as of 2022 (up from $10.8B in 2021), increasingly frequent nuclear verdicts (50% exceeding $25M in 2023), and incumbents operating on outdated technology, we're positioned to transform this market through AI-driven underwriting and real-time risk prevention.</p>

            <p>The incumbent carriers are particularly vulnerable to disruption. Leadership at major insurers routinely stays in power well into their 80s and 90s, creating organizational stagnation and blocking advancement for the next generation. Our conversations with frustrated VP-level executives reveal widespread excitement about the prospect of a new generation of insurers. These geriatric organizations move extremely slowly and will struggle to match our speed of execution and technological innovation.</p>

            <p>Our acquisition and rollup strategy:</p>

            <ul>
                <li>Target physician-owned mutuals and regional carriers through our risk intelligence</li>
                <li>Acquire at significant discounts to book value</li>
                <li>Standardize on our AI platform while maintaining local market presence</li>
                <li>Dramatically improve combined ratios through automation</li>
                <li>Roll up into a national platform with regional expertise</li>
            </ul>

            <p>This creates a virtuous cycle: as we gather more data, our risk models become more accurate, enabling lower premiums and better outcomes. This attracts more providers, generating more data and further improving our models.</p>

            <h3 id="timing">The Timing is Now</h3>

            <p>Four critical factors have converged to create this unique opportunity:</p>

            <ol>
                <li><strong>AI Maturity:</strong> Advanced models can now evaluate medical records with expert-level accuracy</li>
                <li><strong>Regulatory Evolution:</strong> New provisions allowing non-lawyer ownership of legal practices</li>
                <li><strong>Cultural Inflection:</strong> Growing public awareness and frustration with medical errors</li>
                <li><strong>Team Synergy:</strong> Rare combination of AI expertise and elite legal domain experience</li>
            </ol>

            <p>This convergence creates a once-in-a-generation opportunity to transform healthcare accountability and patient protection.</p>

            <h3 id="advocate">Vision 1: An Advocate for the Future of Healthcare</h3>

            <p>The Hippocratic Oath has endured for thousands of years because it speaks to a fundamental truth: medicine is not just a science, but a sacred trust between provider and patient. As healthcare becomes increasingly commodified and automated, this trust becomes more crucial than ever. Patients need someone watching their back – whether they have a case or not.</p>

            <p>Afterimage is building the accountability layer for healthcare's automated future. While technology can improve care delivery, it cannot replace the human need for trust, understanding, and advocacy. Even with perfect care, patients will still face devastating outcomes and need someone to help them make sense of their experience and hold their providers accountable. They'll need a trusted third party that can verify their care, explain what happened, and ensure they're treated with dignity – regardless of whether their situation leads to legal action.</p>

            <p>Our platform combines cutting-edge technology with deep human understanding to ensure that every patient has a powerful ally in their corner. We're creating more than just a service – we're building a brand that patients trust implicitly, one that will resist commodification because of the deep relationships we forge with those we serve. As healthcare continues to evolve, Afterimage will be there to ensure that patients always have someone on their side, fighting for their dignity and justice.</p>

            <h3 id="vision">Vision 2: Restructuring Healthcare Market Dynamics</h3>

            <p>Afterimage is fundamentally reimagining how economic incentives shape patient safety outcomes. By leveraging AI agents to facilitate accountability in legitimate cases while simultaneously filtering out non-meritorious claims, we're creating a precision mechanism that shifts the risk calculation for healthcare systems.</p>

            <p>Our market transformation strategy operates through a four-phase cascade effect:
            </p><ol>
                <li>Democratize access to case evaluation through AI, dramatically lowering the cost threshold for legitimate claim investigation</li>
                <li>Create transparency by enabling patients to efficiently verify diagnostic accuracy when they feel uncertain or frustrated</li>
                <li>Establish economic pressure that makes detecting and being transparent about errors financially advantageous to the status quo of "Cover your ass"</li>
                <li>Facilitate industry-wide adoption of transparent malpractice and negligence detection technology</li>
            </ol>
            <p></p>

            <p>This reconfiguration of market forces will shift healthcare incentives toward prevention instead of concealment.</p>
        </div>
        
        <div class="right-column">
            <!-- Empty right column that balances the left column -->
        </div>
    </div>

    <footer>
        <div class="footer-container">
            <p>Afterimage, Inc. • April 2025 • Confidential</p>
            
            <div style="font-size: 0.8rem; margin-top: 2rem; border-top: 1px solid #eaeaea; padding-top: 1rem;">
                <p><strong>Citations</strong></p>
                <ol>
                    <li class="1">Institute for Healthcare Improvement, "Patient Safety Survey," 2017, https://www.ihi.org/about/news/Documents/IHI_NPSF_Patient_Safety_Survey_2017_Final_Report.pdf</li>
                    <li class="2">Newman-Toker, D.E., et al. "Diagnostic errors in US emergency departments: rate and association with serious patient harm." <em>BMJ Quality &amp; Safety</em> (2024). <a href="https://qualitysafety.bmj.com/content/33/2/109">https://qualitysafety.bmj.com/content/33/2/109</a></li>
                    <li class="3">Andel, C., et al. "The Economics of Health Care Quality and Medical Errors." <em>Journal of Health Care Finance</em> (2012).</li>
                    <li class="4">CRICO Strategies, "Comparative Benchmarking System: Annual Report," 2020.</li>
                    <li class="5">Diagnostic Imaging, "Study Says AI Improves Sensitivity of Fracture Detection by 20 Percent," June 2023, Vol. 45, Issue 6.</li>
                    <li class="6">Justia, "Medical Malpractice Attorney Overview." <a href="https://www.justia.com/injury/medical-malpractice/">https://www.justia.com/injury/medical-malpractice/</a></li>
                    <li class="7">American Association for Justice, "Medical Negligence: The Role of America's Civil Justice System in Protecting Patients' Rights," February 2011. (Including Kaiser Family Foundation survey data and National Practitioner Databank statistics)</li>
                    <li class="8">Columbia University Institute on Medicine as a Profession, "Survey on Physician Professionalism," 2022.</li>
                    <li class="9">Centers for Medicare &amp; Medicaid Services, "National Health Expenditure Data," 2023.</li>
                </ol>
            </div>
        </div>
    </footer>

    <script>
        // Toggle functionality for table of contents
        document.addEventListener('DOMContentLoaded', function() {
            const tocToggle = document.getElementById('tocToggle');
            const tocContent = document.getElementById('tocContent');
            
            // Set initial state (expanded for desktop)
            let isCollapsed = false;
            
            tocToggle.addEventListener('click', function() {
                isCollapsed = !isCollapsed;
                
                if (isCollapsed) {
                    tocToggle.classList.add('collapsed');
                    tocContent.classList.add('collapsed');
                } else {
                    tocToggle.classList.remove('collapsed');
                    tocContent.classList.remove('collapsed');
                }
            });
            
            // Mobile TOC toggle - collapsed by default
            const mobileTocToggle = document.getElementById('mobileTocToggle');
            const mobileTocContent = document.getElementById('mobileTocContent');
            
            if (mobileTocToggle && mobileTocContent) {
                // Set initial state (collapsed for mobile)
                mobileTocToggle.classList.add('collapsed');
                mobileTocContent.classList.add('collapsed');
                
                mobileTocToggle.addEventListener('click', function() {
                    if (mobileTocToggle.classList.contains('collapsed')) {
                        mobileTocToggle.classList.remove('collapsed');
                        mobileTocContent.classList.remove('collapsed');
                    } else {
                        mobileTocToggle.classList.add('collapsed');
                        mobileTocContent.classList.add('collapsed');
                    }
                });
            }
        });
    </script>

</body></html>`;

export default memoContent;
